export default __webpack_public_path__ + "static/media/aglioTtsIt_It60.c2d10466.mp3";